import { useState, useEffect } from 'react';
import ResourceManager from '../components/multiWindowLive/ResourceManager';

/**
 * ResourceManager 用量轮询（1s）+ 定期 forceCleanup。
 * 无变化时不 setState，避免整页重渲闪屏。
 */
export default function useMultiWindowResourceUsage() {
  const [resourceUsage, setResourceUsage] = useState({
    active: 0,
    max: ResourceManager.maxConcurrentPlayers
  });

  useEffect(() => {
    let cleanupTick = 0;
    const updateResourceUsage = () => {
      const status = ResourceManager.getStatus();
      setResourceUsage((prev) => (
        prev.active === status.active && prev.max === status.max
          ? prev
          : { active: status.active, max: status.max }
      ));
      cleanupTick += 1;
      if (cleanupTick % 30 === 0) {
        ResourceManager.forceCleanup();
      }
    };

    const interval = setInterval(updateResourceUsage, 1000);
    return () => clearInterval(interval);
  }, []);

  return { resourceUsage };
}
